import { SVGProps } from 'react';

const SvgTimerSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M5.935 1.333a.5.5 0 0 1 .5-.5h3.478a.5.5 0 0 1 0 1h-.37v1.873a5.818 5.818 0 0 1 2.213 1.164l.644-.644a.5.5 0 0 1 .765-.638l.58.58a.5.5 0 0 1-.638.765l-.644.644a5.833 5.833 0 1 1-5.659-1.954v-1.79h-.37a.5.5 0 0 1-.5-.5Zm1.87.5h.738v1.692a5.906 5.906 0 0 0-.739-.022v-1.67ZM8 4.5a4.833 4.833 0 1 0 0 9.667A4.833 4.833 0 0 0 8 4.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M5.646 6.98a.5.5 0 0 1 .708 0l2 2a.5.5 0 1 1-.708.707l-2-2a.5.5 0 0 1 0-.707Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgTimerSmall;
